export const PRODUCT_POST_MATCH = 'post-match';
export const PRODUCT_FEDERATION = 'federation';

const STORAGE_KEY = 'tactmark_active_product';

export function getStoredProduct() {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value === PRODUCT_FEDERATION || value === PRODUCT_POST_MATCH) return value;
  } catch (_) { /* ignore */ }
  return null;
}

export function setStoredProduct(product) {
  if (product !== PRODUCT_FEDERATION && product !== PRODUCT_POST_MATCH) return;
  try {
    localStorage.setItem(STORAGE_KEY, product);
  } catch (_) { /* ignore */ }
}

export function orgCanAccessFederation(org) {
  return !!(org?.canAccessFederation || org?.productFederationEnabled);
}

export function orgCanAccessPostMatch(org) {
  if (!org) return false;
  return org.canAccessPostMatch === true || org.productPostMatchEnabled === true;
}

/**
 * Post-login destination from authoritative entitlements.
 * Both-product accounts get an explicit chooser unless a safe intended path is provided.
 */
export function resolvePostLoginPath(org, { intendedPath, justSignedUp } = {}) {
  const federation = orgCanAccessFederation(org);
  const postMatch = orgCanAccessPostMatch(org);
  const intended = typeof intendedPath === 'string' ? intendedPath : '';

  if (intended.startsWith('/') && !intended.startsWith('//')) {
    if (intended.startsWith('/federation') && federation) return intended;
    if (!intended.startsWith('/federation') && postMatch && (
      intended.startsWith('/dashboard')
      || intended.startsWith('/upload')
      || intended.startsWith('/matches')
      || intended.startsWith('/reports')
      || intended.startsWith('/teams')
      || intended.startsWith('/settings')
      || intended.startsWith('/players')
      || intended.startsWith('/patterns')
      || intended.startsWith('/memory')
      || intended.startsWith('/analysis')
    )) {
      return intended;
    }
  }

  if (federation && postMatch) {
    const stored = getStoredProduct();
    if (stored === PRODUCT_FEDERATION) return '/federation/dashboard';
    if (stored === PRODUCT_POST_MATCH) return '/dashboard';
    return '/choose-product';
  }
  if (federation && !postMatch) return '/federation/dashboard';
  if (justSignedUp) return '/dashboard';
  return '/dashboard';
}

/**
 * Resolve which product workspace is active for the current org + route.
 * Path wins for federation routes; otherwise prefer sole entitlement, then stored, then post-match.
 */
export function resolveActiveProduct(org, pathname = '') {
  const path = String(pathname || '');
  if (path.startsWith('/federation') || path.startsWith('/app/federation')) {
    return PRODUCT_FEDERATION;
  }

  const federation = orgCanAccessFederation(org);
  const postMatch = orgCanAccessPostMatch(org);

  if (federation && !postMatch) return PRODUCT_FEDERATION;
  if (postMatch && !federation) return PRODUCT_POST_MATCH;

  const stored = getStoredProduct();
  if (stored === PRODUCT_FEDERATION && federation) return PRODUCT_FEDERATION;
  if (stored === PRODUCT_POST_MATCH && postMatch) return PRODUCT_POST_MATCH;

  return PRODUCT_POST_MATCH;
}
